var map = {
	"./1-AX.png": 66935,
	"./2-AX.png": 79222,
	"./3-AX.png": 54927,
	"./4-AX.png": 20346,
	"./5-AX.png": 74391,
	"components/Catalog/AX/img/allDoor/Bronze/1-AX.png": 66935,
	"components/Catalog/AX/img/allDoor/Bronze/2-AX.png": 79222,
	"components/Catalog/AX/img/allDoor/Bronze/3-AX.png": 54927,
	"components/Catalog/AX/img/allDoor/Bronze/4-AX.png": 20346,
	"components/Catalog/AX/img/allDoor/Bronze/5-AX.png": 74391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1013;